var _defineProperty = require("/var/lib/jenkins/workspace/HFM_MS_R6.10_Oct17-CustomerEngage_AM_warfilebuild-PROD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

module.exports = function (modules) {
  var installedModules = {};

  function __webpack_require__(moduleId) {
    if (installedModules[moduleId]) return installedModules[moduleId].exports;
    var module = installedModules[moduleId] = {
      i: moduleId,
      l: !1,
      exports: {}
    };
    return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), module.l = !0, module.exports;
  }

  return __webpack_require__.m = modules, __webpack_require__.c = installedModules, __webpack_require__.d = function (exports, name, getter) {
    __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
      enumerable: !0,
      get: getter
    });
  }, __webpack_require__.r = function (exports) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(exports, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(exports, "__esModule", {
      value: !0
    });
  }, __webpack_require__.t = function (value, mode) {
    if (1 & mode && (value = __webpack_require__(value)), 8 & mode) return value;
    if (4 & mode && "object" == typeof value && value && value.__esModule) return value;
    var ns = Object.create(null);
    if (__webpack_require__.r(ns), Object.defineProperty(ns, "default", {
      enumerable: !0,
      value: value
    }), 2 & mode && "string" != typeof value) for (var key in value) {
      __webpack_require__.d(ns, key, function (key) {
        return value[key];
      }.bind(null, key));
    }
    return ns;
  }, __webpack_require__.n = function (module) {
    var getter = module && module.__esModule ? function () {
      return module.default;
    } : function () {
      return module;
    };
    return __webpack_require__.d(getter, "a", getter), getter;
  }, __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = "./index.js");
}({
  "../../node_modules/webpack/buildin/global.js": function node_modulesWebpackBuildinGlobalJs(module, exports) {
    var g;

    g = function () {
      return this;
    }();

    try {
      g = g || new Function("return this")();
    } catch (e) {
      "object" == typeof window && (g = window);
    }

    module.exports = g;
  },
  "./index.js": function indexJs(module, __webpack_exports__, __webpack_require__) {
    "use strict";

    __webpack_require__.r(__webpack_exports__), function (global) {
      __webpack_require__.d(__webpack_exports__, "setTranslations", function () {
        return setTranslations;
      }), __webpack_require__.d(__webpack_exports__, "hasDisplayKey", function () {
        return hasDisplayKey;
      }), __webpack_require__.d(__webpack_exports__, "addTranslations", function () {
        return addTranslations;
      }), __webpack_require__.d(__webpack_exports__, "translateDisplayKey", function () {
        return translateDisplayKey;
      }), __webpack_require__.d(__webpack_exports__, "translateDisplayKeyWithFallback", function () {
        return translateDisplayKeyWithFallback;
      });

      __webpack_require__("core-js/modules/es.string.replace");

      var _babel_runtime_corejs3_core_js_stable_instance_keys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/keys"),
          _babel_runtime_corejs3_core_js_stable_instance_keys__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_keys__WEBPACK_IMPORTED_MODULE_1__),
          _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/instance/for-each"),
          _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2__),
          _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("@babel/runtime-corejs3/core-js-stable/symbol/for"),
          _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_3___default = __webpack_require__.n(_babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_3__),
          lodash__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("lodash"),
          lodash__WEBPACK_IMPORTED_MODULE_4___default = __webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_4__),
          _jutro_logger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("@jutro/logger");

      var TRANSLATIONS_DISPLAY_KEYS_KEY = _babel_runtime_corejs3_core_js_stable_symbol_for__WEBPACK_IMPORTED_MODULE_3___default()("jutro.translator.displayKeys"),
          getDisplayKeys = function getDisplayKeys() {
        return global[TRANSLATIONS_DISPLAY_KEYS_KEY] || {};
      },
          getDisplayKey = function getDisplayKey(key, defaultMessage) {
        var keys = getDisplayKeys();
        return keys.hasOwnProperty(key) ? keys[key] : defaultMessage || key;
      },
          setTranslations = function setTranslations(keys) {
        global[TRANSLATIONS_DISPLAY_KEYS_KEY] = _objectSpread({}, keys);
      },
          hasDisplayKey = function hasDisplayKey(key) {
        return global[TRANSLATIONS_DISPLAY_KEYS_KEY] && global[TRANSLATIONS_DISPLAY_KEYS_KEY].hasOwnProperty(key);
      },
          addTranslations = function addTranslations(keys) {
        global[TRANSLATIONS_DISPLAY_KEYS_KEY] = _objectSpread({}, getDisplayKeys(), {}, keys);
      },
          translateDisplayKey = function translateDisplayKey(key) {
        return getDisplayKey(key, "displaykey not found");
      },
          translateDisplayKeyWithFallback = function translateDisplayKeyWithFallback(key, args) {
        return Object(_jutro_logger__WEBPACK_IMPORTED_MODULE_5__.warning)('The function "translateDisplayKeyWithFallback" has been deprecated - please use TranslatorProvider instead.'), isKeySupportedByTranslator(key) ? lodash__WEBPACK_IMPORTED_MODULE_4___default.a.isString(key) ? translateResolvedDisplayKey(key, null, args) : translateResolvedDisplayKey(key.id, key.defaultMessage, args) : key;
      },
          translateResolvedDisplayKey = function translateResolvedDisplayKey(key, defaultMessage) {
        var result = getDisplayKey(key, defaultMessage);

        for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        return args.length && _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2___default()(args).call(args, function (value, index) {
          var _context;

          lodash__WEBPACK_IMPORTED_MODULE_4___default.a.isObject(value) ? _babel_runtime_corejs3_core_js_stable_instance_for_each__WEBPACK_IMPORTED_MODULE_2___default()(_context = _babel_runtime_corejs3_core_js_stable_instance_keys__WEBPACK_IMPORTED_MODULE_1___default()(lodash__WEBPACK_IMPORTED_MODULE_4___default.a).call(lodash__WEBPACK_IMPORTED_MODULE_4___default.a, value)).call(_context, function (valueKey) {
            result = result.replace("{".concat(valueKey, "}"), value[valueKey]);
          }) : result = result.replace("{_".concat(index, "}"), value);
        }), result;
      },
          isKeySupportedByTranslator = function isKeySupportedByTranslator(obj) {
        return lodash__WEBPACK_IMPORTED_MODULE_4___default.a.isString(obj) || isIntlMessage(obj);
      },
          isIntlMessage = function isIntlMessage(obj) {
        return lodash__WEBPACK_IMPORTED_MODULE_4___default.a.isObject(obj) && lodash__WEBPACK_IMPORTED_MODULE_4___default.a.isString(obj.id) && lodash__WEBPACK_IMPORTED_MODULE_4___default.a.isString(obj.defaultMessage);
      };

      __webpack_exports__.default = translateDisplayKeyWithFallback;
    }.call(this, __webpack_require__("../../node_modules/webpack/buildin/global.js"));
  },
  "@babel/runtime-corejs3/core-js-stable/instance/for-each": function babelRuntimeCorejs3CoreJsStableInstanceForEach(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
  },
  "@babel/runtime-corejs3/core-js-stable/instance/keys": function babelRuntimeCorejs3CoreJsStableInstanceKeys(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/instance/keys");
  },
  "@babel/runtime-corejs3/core-js-stable/symbol/for": function babelRuntimeCorejs3CoreJsStableSymbolFor(module, exports) {
    module.exports = require("@babel/runtime-corejs3/core-js-stable/symbol/for");
  },
  "@jutro/logger": function jutroLogger(module, exports) {
    module.exports = require("@jutro/logger");
  },
  "core-js/modules/es.string.replace": function coreJsModulesEsStringReplace(module, exports) {
    module.exports = require("core-js/modules/es.string.replace");
  },
  lodash: function lodash(module, exports) {
    module.exports = require("lodash");
  }
});